<template>
  <div v-loading="loading" class="oauth" element-loading-text="正在跳转中...">
    <div class="oauth-panel">
      <!-- 部政务平台来源说明 -->
      <div v-if="fromGab" class="gab-banner">
        <div class="gab-banner-title">
          <i class="el-icon-connection"></i>
          您正在通过「公安部政务服务平台」登录易制毒化学品管理服务平台
          <el-tag v-if="identityTypeLabel" size="mini" type="success">{{ identityTypeLabel }}</el-tag>
        </div>
        <div class="gab-banner-info">
          <template v-if="carriedFields.length">
            <span class="gab-banner-label">平台已携带：</span>
            <span v-for="item in carriedFields" :key="item.label" class="gab-info-item">
              {{ item.label }}：{{ item.value }}
            </span>
          </template>
          <span v-else>{{ bannerHint }}</span>
        </div>
      </div>

      <!-- 错误提示 -->
      <el-result v-if="msg" icon="error" title="无法登录" :sub-title="msg">
        <template slot="extra">
          <el-button
            v-if="gabNotLogin"
            type="primary"
            size="medium"
            @click="toGabLogin"
          >前往部政务平台登录</el-button>
          <el-button
            v-if="gabNotLogin"
            size="medium"
            @click="$router.push('/login')"
          >本地账号登录</el-button>
          <el-button
            size="medium"
            @click="goback"
          >返回政务大厅</el-button>
        </template>
      </el-result>

      <!-- 登录成功倒计时 -->
      <el-result v-if="countdownVisible" icon="success" title="登录成功" :sub-title="countdownText">
        <template slot="extra">
          <el-button type="primary" size="medium" @click="enterNow">立即进入</el-button>
          <el-button size="medium" @click="goback">返回政务大厅</el-button>
        </template>
      </el-result>
    </div>

    <!-- 部政务平台用户补全注册 -->
    <el-dialog
      :title="registerTitle"
      :visible.sync="registerVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
    >
      <div class="register-tip">{{ registerReason }}</div>

      <el-descriptions
        v-if="carriedFields.length"
        class="carried-box"
        title="部政务服务平台携带的信息"
        :column="2"
        size="small"
        border
      >
        <el-descriptions-item
          v-for="item in carriedFields"
          :key="item.label"
          :label="item.label"
        >{{ item.value }}</el-descriptions-item>
      </el-descriptions>

      <el-form
        ref="registerForm"
        :model="registerForm"
        :rules="registerRules"
        label-width="130px"
        style="margin-top: 15px"
      >
        <template v-if="isCorpJoin">
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="registerForm.sex">
              <el-radio label="0">男</el-radio>
              <el-radio label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="出生日期" prop="birthday">
            <el-date-picker
              v-model="registerForm.birthday"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择出生日期"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="证件有效期" required>
            <el-col :span="11">
              <el-form-item prop="certBeginDate">
                <el-date-picker
                  v-model="registerForm.certBeginDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="2" style="text-align: center">至</el-col>
            <el-col :span="11">
              <el-form-item prop="certEndDate">
                <el-date-picker
                  v-model="registerForm.certEndDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="结束日期"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="岗位" prop="gw">
            <el-select
              v-model="registerForm.gw"
              multiple
              placeholder="请选择岗位"
              style="width: 100%"
            >
              <el-option
                v-for="item in gwOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="聘用时间" prop="pysj">
            <el-date-picker
              v-model="registerForm.pysj"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择聘用时间"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="籍贯" prop="jg">
            <el-input v-model="registerForm.jg" placeholder="选填" />
          </el-form-item>
        </template>
        <el-form-item label="登录密码" prop="password">
          <el-input
            v-model="registerForm.password"
            size="small"
            placeholder="请输入密码"
            autocomplete="new-password"
            show-password
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="passwordAgain">
          <el-input
            v-model="registerForm.passwordAgain"
            size="small"
            placeholder="请再次输入密码"
            autocomplete="new-password"
            show-password
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="goback">返回政务大厅</el-button>
        <el-button size="small" @click="$router.push('/login')">前往登录</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="registerLoading"
          @click="submitRegister"
        >{{ isCorpJoin ? '提交并加入企业' : '注册并登录' }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { oAuth, oAuth626, gabRegister } from '@/assets/js/system.js'
import { getkv } from '@/assets/js/common.js'
import { setFrameDisplay, setToken, setToken626 } from '@/utils/tool'

const IDENTITY_LABELS = {
  NA: '自然人',
  CP: '法人',
  PY: '经办人'
}

export default {
  data() {
    const pwdValidate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('密码不能为空!'))
      } else {
        const reg = /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,}$))/
        if (!reg.test(value)) {
          callback(new Error('密码必须同时包含大写、小写、数字和特殊字符其中三项且至少8位'))
        } else {
          callback()
        }
      }
    }
    const passwordValidate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码!'))
      } else if (this.registerForm.password !== value) {
        callback(new Error('两次密码不一致,请重新确认!'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      msg: '',
      // 是否来自部政务平台（626 等其他入口不显示部平台说明）
      fromGab: true,
      // 部平台未检测到登录状态
      gabNotLogin: false,
      // 部平台身份信息
      identityType: '',
      identityTypeLabel: '',
      registerInfo: {},
      bannerHint: '正在从部政务服务平台获取您的身份信息...',
      // 补全注册
      registerVisible: false,
      registerLoading: false,
      registerTicket: '',
      registerMode: '',
      registerUnitName: '',
      gwOptions: [],
      registerForm: {
        password: '',
        passwordAgain: '',
        sex: '',
        birthday: '',
        certBeginDate: '',
        certEndDate: '',
        gw: [],
        pysj: '',
        jg: ''
      },
      registerRules: {
        password: [
          { required: true, validator: pwdValidate, trigger: 'change' }
        ],
        passwordAgain: [
          { required: true, validator: passwordValidate, trigger: 'blur' }
        ],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        birthday: [{ required: true, message: '请选择出生日期', trigger: 'change' }],
        certBeginDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
        certEndDate: [{ required: true, message: '请选择结束日期', trigger: 'change' }],
        gw: [{ required: true, message: '请选择岗位', trigger: 'change' }],
        pysj: [{ required: true, message: '请选择聘用时间', trigger: 'change' }]
      },
      // 登录成功倒计时
      countdownVisible: false,
      countdownSeconds: 5,
      countdownTimer: null,
      pendingRedirect: ''
    }
  },
  computed: {
    carriedFields() {
      const info = this.registerInfo || {}
      const fields = [
        ['姓名', info.userName],
        ['手机号', info.phonenumber],
        ['身份证号', info.idCard],
        ['单位名称', info.corpName],
        ['统一社会信用代码', info.certificateSno],
        ['法定代表人', info.legalName]
      ]
      return fields
        .filter(item => item[1])
        .map(item => ({ label: item[0], value: item[1] }))
    },
    isCorpJoin() {
      return this.registerMode === 'CORP_JOIN'
    },
    registerTitle() {
      if (this.registerMode === 'CORP_JOIN') {
        return '加入已有企业'
      }
      if (this.registerMode === 'CORP_REGISTER') {
        return '完成企业注册'
      }
      return '完善注册信息'
    },
    registerReason() {
      const unitName = this.registerUnitName ? `「${this.registerUnitName}」` : ''
      if (this.registerMode === 'CORP_JOIN') {
        return `本系统中已存在企业${unitName}，但该手机号尚未开通账号。请设置登录密码并补充岗位、聘用时间等信息；提交后将自动加入该企业从业人员并成为次信息员。`
      }
      if (this.registerMode === 'CORP_REGISTER') {
        return '本系统未找到该企业和该手机号对应的账号。请设置登录密码完成注册，平台已带入企业和人员信息，注册后将直接进入企业入网申请页面。'
      }
      return '本系统未找到该手机号对应的账号。请设置登录密码完成注册，平台已带入您的实名信息，注册后将直接进入企业入网申请页面。'
    },
    countdownText() {
      return `身份信息已同步，${this.countdownSeconds} 秒后自动进入系统`
    }
  },
  mounted() {
    const query = this.$route.query
    // 过滤旧链接拼接出的字面量 undefined/null
    const norm = (v) => (!v || v === 'undefined' || v === 'null') ? '' : v
    const authCode = norm(query.code) || norm(query.authCode)
    const ticket = norm(query.ticket)
    if (ticket || authCode) {
      this.login(authCode, ticket)
    } else if (query.ticket626) {
      this.fromGab = false
      this.loginBy626(query.ticket626, query.url)
    } else if (query.flag === 'false') {
      // 部平台未登录：给出提示，引导去部平台登录或使用本地账号
      this.loading = false
      this.gabNotLogin = true
      this.bannerHint = '部政务服务平台未检测到已登录状态'
      this.msg = '公安部政务服务平台未检测到已登录状态，请先登录部政务平台后再进入本系统。'
    } else {
      this.loading = false
      this.bannerHint = '未获取到部政务服务平台的授权信息'
      this.msg = '未获取到授权信息，请从公安部政务服务平台重新进入'
    }
  },
  beforeDestroy() {
    this.clearCountdown()
  },
  methods: {
    goback() {
      window.location.href = 'https://zwfw.mps.gov.cn/'
    },
    // 前往部平台显性登录，登录成功后回调本系统 oAuth 页
    toGabLogin() {
      window.location.href = window.location.origin + '/openJk/gabzw/oauth'
    },
    login(code, ticket) {
      oAuth(code, ticket).then(e => {
        if (e.status === 200) {
          this.loading = false
          this.applyGabMeta(e.data)
          if (e.data.needRegister) {
            this.registerTicket = e.data.registerTicket
            this.registerMode = e.data.registerMode || ''
            this.registerUnitName = e.data.registerInfo ? (e.data.registerInfo.corpName || '') : ''
            this.loadRegisterForm(e.data.registerInfo || {})
            this.registerVisible = true
            return
          }
          this.handleLoginSuccess(e.data)
        } else {
          this.showError(e)
        }
      }).catch(e => {
        this.showError(e)
      })
    },
    applyGabMeta(data) {
      if (!data) {
        return
      }
      this.identityType = data.identityType || ''
      this.identityTypeLabel = IDENTITY_LABELS[this.identityType] || ''
      if (data.registerInfo) {
        this.registerInfo = data.registerInfo
      }
      this.bannerHint = this.carriedFields.length
        ? '' : '部政务服务平台未返回可展示的身份信息'
    },
    loadRegisterForm(info) {
      const dateOnly = (v) => (v && /^\d{4}-\d{2}-\d{2}$/.test(v)) ? v : ''
      this.registerForm = {
        password: '',
        passwordAgain: '',
        sex: (info.sex === '0' || info.sex === '1') ? info.sex : '',
        birthday: dateOnly(info.birthday),
        certBeginDate: dateOnly(info.certBeginDate),
        certEndDate: dateOnly(info.certEndDate),
        gw: [],
        pysj: '',
        jg: ''
      }
      if (this.registerMode === 'CORP_JOIN' && this.gwOptions.length === 0) {
        getkv('yzd_cyry_gw').then(e => {
          this.gwOptions = e.data.data || []
        }).catch(() => {
          this.gwOptions = []
        })
      }
    },
    submitRegister() {
      this.$refs.registerForm.validate(valid => {
        if (!valid) {
          return
        }
        const data = {
          registerTicket: this.registerTicket,
          password: this.registerForm.password,
          passwordAgain: this.registerForm.passwordAgain
        }
        if (this.isCorpJoin) {
          data.sex = this.registerForm.sex
          data.birthday = this.registerForm.birthday
          data.certBeginDate = this.registerForm.certBeginDate
          data.certEndDate = this.registerForm.certEndDate
          data.gw = (this.registerForm.gw || []).join(',')
          data.pysj = this.registerForm.pysj
          data.jg = this.registerForm.jg
        }
        this.registerLoading = true
        gabRegister(data).then(e => {
          this.registerLoading = false
          if (e.status === 200) {
            this.registerVisible = false
            this.applyGabMeta(e.data)
            this.handleLoginSuccess(e.data)
          } else {
            this.showError(e)
          }
        }).catch(() => {
          this.registerLoading = false
        })
      })
    },
    handleLoginSuccess(data) {
      var token = data.tokenType + data.accessToken
      var time = data.expiresIn - 60 + 's'
      // 填写Date对象，明确指定过期时间
      setToken(token, time, data)

      // 判断单位审核状态
      //  1 审批通过
      //  0 正在审批中
      //  3 审批未通过
      //  5 未入网
      const qyState = Number(data.qyState)
      if (qyState === 5) {
        // 未申请
        this.pendingRedirect = '/Rwsq'
      } else if (qyState === 1) {
        // 申请通过
        if (data.isInit === true) {
          // 跳转库存初始化
          this.pendingRedirect = '/Kccshlc'
        } else {
          // 跳转首页
          this.pendingRedirect = '/Dashboard'
        }
      } else if (qyState === 3) {
        // 未通过
        this.pendingRedirect = '/Spfail'
      } else if (qyState === 0) {
        // 审核中
        this.pendingRedirect = '/Spload'
      } else {
        this.pendingRedirect = '/Dashboard'
      }
      this.loading = false
      if (data.showCountdown === true) {
        this.startCountdown()
      } else {
        this.redirectNow()
      }
    },
    startCountdown() {
      this.countdownVisible = true
      this.countdownSeconds = 5
      this.clearCountdown()
      this.countdownTimer = setInterval(() => {
        this.countdownSeconds -= 1
        if (this.countdownSeconds <= 0) {
          this.redirectNow()
        }
      }, 1000)
    },
    clearCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    },
    enterNow() {
      this.redirectNow()
    },
    redirectNow() {
      this.clearCountdown()
      this.countdownVisible = false
      this.$message({
        type: 'success',
        message: '登录成功，正在跳转'
      })
      this.$router.push(this.pendingRedirect || '/Dashboard')
    },
    showError(e) {
      this.loading = false
      let msg = ''
      if (e.response && e.response.data) {
        msg = e.response.data.mesg
      } else if (e.data) {
        msg = e.data.mesg
      }
      this.msg = msg || '操作失败'
    },
    loginBy626(ticket, url) {
      oAuth626(ticket).then(e => {
        if (e.status === 200) {
          var token = e.data.tokenType + e.data.accessToken
          var time = e.data.expiresIn - 60 + 's'
          setToken626(token, time, e.data)

          setFrameDisplay(false)
          // 跳转首页
          if (!url) {
            url = '/Gmsq'
          }
          this.$router.push(url)
          this.loading = false
        }
      }).catch(e => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.oauth {
  min-height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
}
.oauth-panel {
  width: 760px;
  max-width: 94vw;
}
.gab-banner {
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  border-radius: 6px;
  padding: 14px 18px;
  margin-bottom: 18px;
}
.gab-banner-title {
  color: #303133;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
}
.gab-banner-title i {
  color: #409eff;
  margin-right: 6px;
}
.gab-banner-info {
  margin-top: 8px;
  color: #606266;
  font-size: 13px;
  line-height: 22px;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  row-gap: 2px;
  column-gap: 16px;
}
.gab-banner-label {
  color: #909399;
  flex-shrink: 0;
}
.gab-info-item {
  white-space: nowrap;
}
.register-tip {
  color: #606266;
  font-size: 14px;
  line-height: 22px;
  background: #f4f8ff;
  border-radius: 4px;
  padding: 10px 12px;
}
.carried-box {
  margin-top: 14px;
}
</style>
